<!--
  Voluntary Respirator Use Form

  Step-by-step form with:
  - 2 steps: Respirator Details, Employee Acknowledgment
  - Step 1: Employee Information section + Respirator Information section
  - Step 2: Employee Acknowledgment (signature sign-off)
-->

<!-- Use the form layout component to handle the wizard UI -->
<app-form-layout
  [title]="formTitle"
  [form]="form"
  [icon]="formIcon"
  [disabled]="submitting"
  [onSubmit]="onSubmit.bind(this)"
  [steps]="steps"
  [currentStep]="currentStep()"
  [completedSteps]="completedSteps()"
  [canNavigateToStep]="canNavigateToStep.bind(this)"
  [isStepCompleted]="isStepCompleted.bind(this)"
  [onNextStep]="onNextStep.bind(this)"
  [onPreviousStep]="onPreviousStep.bind(this)"
  [getProgressPercentage]="getProgressPercentage.bind(this)"
>
  <div
    *ngIf="form && fieldMappings"
    formContent
    [formGroup]="form"
    class="form-content"
  >
    <!-- Respirator Details Step -->
    <div *ngIf="currentStep() === steps[0].id" class="step-content">
      <ion-list>
        <ion-item-divider class="form-step-title">
          <ion-label>
            <h1>{{ steps[0].title }}</h1>
            <p>{{ steps[0].description }}</p>
          </ion-label>
        </ion-item-divider>

      


  


        <ion-grid>

               <ion-row>

                      <!-- Purpose  Section -->
          <ion-card      *ngIf="purposeParagraph" color="primary" class="information-card">
            <ion-card-header><ion-card-title>&nbsp;{{ steps[0].sections?.[0]?.title }}</ion-card-title></ion-card-header>
            <ion-card-content>
              <ion-text>
                <h4>{{ purposeParagraph.content }}</h4>
              </ion-text>
            </ion-card-content>
          </ion-card>        </ion-row>
     

                  <!-- Employee Information Section -->
        <ion-item-divider class="form-section-title">
          <ion-label>
            <h2>{{ steps[0].sections?.[1]?.title }}</h2>
          </ion-label>
        </ion-item-divider>


          <ion-row>
            <ion-col size="12" size-md="6">
              <app-text-input
                [templateFormGroup]="respiratorDetailsFormGroup"
                [control]="respiratorDetailsFormGroup.get('employeeName')!"
                [label]="fieldMappings['employeeName']"
                [requiredField]="requiredFields['employeeName']"
                placeholder="Enter employee name"
              >
              </app-text-input>
            </ion-col>
            <ion-col size="12" size-md="6">
              <app-text-input
                [templateFormGroup]="respiratorDetailsFormGroup"
                [control]="respiratorDetailsFormGroup.get('jobTitle')!"
                [label]="fieldMappings['jobTitle']"
                [requiredField]="requiredFields['jobTitle']"
                placeholder="Enter job title"
              >
              </app-text-input>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="12" size-md="6">
              <app-text-input
                [templateFormGroup]="respiratorDetailsFormGroup"
                [control]="respiratorDetailsFormGroup.get('department')!"
                [label]="fieldMappings['department']"
                [requiredField]="requiredFields['department']"
                placeholder="Enter department"
              >
              </app-text-input>
            </ion-col>
          </ion-row>
        </ion-grid>

        <!-- Respirator Information Section -->
        <ion-item-divider class="form-section-title">
          <ion-label>
            <h2>{{ steps[0].sections?.[2]?.title }}</h2>
          </ion-label>
        </ion-item-divider>

        <ion-item-divider class="form-subsection-title">
          <ion-label>
            <h2>{{ steps[0].sections?.[2]?.subtitle }}</h2>
          </ion-label>
        </ion-item-divider>

        <ion-grid>
          <ion-row>
            <ion-col size="12" size-md="6">
              <ion-label
                ><b>{{ fieldMappings["respiratorType"] }}:</b></ion-label
              >
              <p>
                <ion-text>{{
                  respiratorDetailsFormGroup.get("respiratorType")!.value
                }}</ion-text>
              </p>
              <!-- <app-select-input
              [disabled]="true"
                [templateFormGroup]="respiratorDetailsFormGroup"
                [control]="respiratorDetailsFormGroup.get('respiratorType')!"
                [label]="fieldMappings['respiratorType']"
                [requiredField]="requiredFields['respiratorType']"
                [options]="respiratorTypeOptions"
              >
              </app-select-input> -->
            </ion-col>
            <ion-col size="12" size-md="6">
              <app-radio-group-input
                [templateFormGroup]="respiratorDetailsFormGroup"
                [control]="
                  respiratorDetailsFormGroup.get('isPersonalProperty')!
                "
                [label]="fieldMappings['isPersonalProperty']"
                [requiredField]="requiredFields['isPersonalProperty']"
                [options]="['Yes', 'No (company provided)']"
              >
              </app-radio-group-input>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-list>
    </div>




    <!-- Employee Acknowledgment Step -->
    <div *ngIf="currentStep() === steps[1].id" class="step-content">
      <ion-list>
        <ion-item-divider class="form-step-title">
          <ion-label>
            <h1>{{ steps[1].title }}</h1>
            <p>{{ steps[1].description }}</p>
          </ion-label>
        </ion-item-divider>

        <ion-grid>
          <!-- Regulatory Information Section -->
          <ion-item-divider class="form-section-title">
            <ion-label>
              <h2>{{ steps[1].sections?.[0]?.title }}</h2>
            </ion-label>
          </ion-item-divider>

          <ion-row>
            <ion-card
              *ngIf="regulatoryCard"
              class="information-card regulatory-info-card"
            >
              <ion-card-header>
                <ion-card-title>
                  <ion-icon name="information-circle-outline"></ion-icon
                  >&nbsp;{{ regulatoryCard.title }}
                </ion-card-title>
                <ion-card-subtitle *ngIf="regulatoryCard.subtitle">{{
                  regulatoryCard.subtitle
                }}</ion-card-subtitle>
              </ion-card-header>
              <ion-card-content>
                <p
                  *ngIf="regulatoryCard.listTopper"
                  class="regulatory-list-topper"
                >
                  {{ regulatoryCard.listTopper }}
                </p>
                <ol class="regulatory-list">
                  <li *ngFor="let item of regulatoryCard.listItems">
                    <span [innerHTML]="item.text"></span>
                    <ul
                      *ngIf="item.subItems?.length"
                      class="regulatory-sublist"
                    >
                      <li
                        *ngFor="let subItem of item.subItems"
                        [innerHTML]="subItem"
                      ></li>
                    </ul>
                  </li>
                </ol>
              </ion-card-content>
            </ion-card>
          </ion-row>

          <!-- Employee Acknowledgment Section -->
          <ion-item-divider class="form-section-title">
            <ion-label>
              <h2>{{ steps[1].sections?.[1]?.title }}</h2>
            </ion-label>
          </ion-item-divider>

          <ion-row
            *ngFor="let signature of formAttachmentRequirements?.signatures"
          >
            <ion-col size="12">
              <app-signature-section
                [signatureInfo]="signature"
              ></app-signature-section>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="12">
              <app-date-input
                [templateFormGroup]="acknowledgementFormGroup"
                [control]="acknowledgementFormGroup.get('signatureDate')!"
                [label]="fieldMappings['signatureDate']"
                [requiredField]="requiredFields['signatureDate']"
                [today]="true"
              >
              </app-date-input>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-list>
    </div>
  </div>
</app-form-layout>
